<template>
  <div>
    <div class="settings-stage">


      <section class="admin-section" aria-labelledby="admin-actions-heading">
        <div>
          <PackagesManagerSettingsList />

        </div>
      </section>

      <section class="admin-section" aria-labelledby="admin-actions-heading">
        <div class="admin-header">
          <div class="admin-title-row">
            <h5 id="admin-actions-heading" class="admin-title">Administracja</h5>
            <span class="admin-badge">Sekcja tylko dla administratora</span>
          </div>
          <p class="admin-description">
            Narzędzia administracyjne związane z zarządzaniem paczkami i danymi. W przyszłości znajdą się tu dodatkowe akcje.
          </p>
        </div>
        <div class="admin-actions">
          <button
            class="admin-action admin-action--primary"
            type="button"
            @click="runStockCalcProcedureWithWarning"
          >
            <span class="admin-action__icon" aria-hidden="true">⚙️</span>
            <span class="admin-action__content">
              <span class="admin-action__title">Przelicz stany magazynowe</span>
              <span class="admin-action__subtitle">Uruchom procedurę przeliczenia.</span>
              <span class="admin-action__subtitle"><b>Ostatnio uruchomione: {{lastCalcSetting}}</b></span>
            </span>
          </button>
          <!-- Przyszłe akcje administracyjne można dodawać jako kolejne przyciski w tej siatce -->
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import PackagesManagerSettingsList from "./PackagesManagerSettingsList";
import Swal from "sweetalert2";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";


export default {
  name: "PackagesManagerSettings",
  components: {
    PackagesManagerSettingsList,
  },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },

  },
  data() {
    return {
      elementsEnabled: true,
      opacityStyle: "opacity:1;",
      lastCalcSetting:null
    };
  },
  methods: {
    fetchLastCalcDatetime(){
      this.packagesModule.httpGetPackagesManagerSettings({}).then(() => {
        const currentSettings = JSON.parse(JSON.stringify(this.packagesModule.getPackagesManagerSettings));
        // find the packages.settings.lastStockCalcDateTimeKey setting
        const lastCalculationSetting = currentSettings.find(setting => setting.name === "packages.settings.lastStockCalcDateTimeKey");
        this.lastCalcSetting = lastCalculationSetting ? lastCalculationSetting.value : "Nigdy";

      });

    },
    runStockCalcProcedureWithWarning(){
      Swal.fire({
        title: 'Czy na pewno chcesz uruchomić procedurę przeliczania stanów magazynowych?',
        text: "Operacja może potrwać kilka minut i obciążyć serwer. Upewnij się, że nikt inny nie korzysta z systemu w tym czasie.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, uruchom procedurę',
        cancelButtonText: 'Anuluj'
      }).then((result) => {
        if (result.isConfirmed) {
          this.runStockCalcProcedure();
        }
      });
    },
    runStockCalcProcedure(){
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.packagesModule.httpGetRunStockCalcProcedure()
    },

  },
  watch: {
  },
  mounted(){
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-package me-1"></i> Ustawienia Zamówień Centralnych`)
  },
  created() {
    this.simplepharmAuth.refreshToken().then(()=>{
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    })
    this.fetchLastCalcDatetime();
  },
};
</script>

<style scoped>
.settings-stage {
  background: #fafafa;
  margin-left: 16px;
  margin-right: 16px;
}

</style>
